import { useContext } from 'react';
import Button from 'components/button';
import Icon from 'components/icons';
import { SessionContext } from 'contexts/session';
import { buildContactSalesMailto } from 'utils/contactSales';
import { AwardBadge, Description, NoVouchersContainer, Title } from './styles';

const CertificationsNoVouchers = (): JSX.Element => {
  const { account } = useContext(SessionContext);

  const handleContactSales = () => {
    window.location.href = buildContactSalesMailto(account);
  };

  return (
    <NoVouchersContainer>
      <AwardBadge>
        <Icon icon="Award" color="var(--lilac-dark, #7965c6)" size="large" />
      </AwardBadge>
      <Title>No vouchers yet</Title>
      <Description>
        Certifications prove your team is ready to tackle real-world challenges. Add vouchers to
        assign to members, then track progress from first attempt to final pass.
      </Description>
      <Button $primary size="small" onClick={handleContactSales}>
        Contact sales to add vouchers
      </Button>
    </NoVouchersContainer>
  );
};

export default CertificationsNoVouchers;
